import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Window from "../components/Window";
import Password from "../components/Password";
import Loading from "../components/Loading";
import {
  collection,
  addDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
} from "firebase/firestore";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { db, storage } from "../firebase";

const Trpg = () => {
  const [passwordMode, setPasswordMode] = useState(null);
  const [showUpload, setShowUpload] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");

  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);

  const [loading, setLoading] = useState(false);

  // 데이터 불러오기 (최신순 아님, 오름차순)
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const collRef = collection(db, "trpg");
        const q = query(collRef, orderBy("createdAt", "asc"));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setItems(data);
      } catch (e) {
        console.error(e);
      }
    };
    fetchItems();
  }, []);

  const total = items.length;

  // 이전 다음 버튼
  const handlePrev = () => setIndex((prev) => (prev - 1 + total) % total);
  const handleNext = () => setIndex((prev) => (prev + 1) % total);

  // 5개 슬라이드 아이템 가져오기 (-2 ~ +2)
  const getFiveItems = () => {
    if (total === 0) return [];
    return [
      items[(index - 2 + total) % total],
      items[(index - 1 + total) % total],
      items[index % total],
      items[(index + 1) % total],
      items[(index + 2) % total],
    ];
  };

  // 포지션별 스타일 지정
  const getStyleForPosition = (pos) => {
    switch (pos) {
      case 0:
        return {
          opacity: 0,
          pointerEvents: "none",
          transform: "translate(-50vw, -50%)",
          zIndex: 0,
          transition: "all 0.5s ease",
        };
      case 4: // 가장 왼쪽, 가장 오른쪽은 숨김
        return {
          opacity: 0,
          pointerEvents: "none",
          transform: "translate(50vw, -50%)",
          zIndex: 0,
          transition: "all 0.5s ease",
        };
      case 1: // 왼쪽 중간
        return {
          opacity: 0.5,
          pointerEvents: "none",
          transform: "translate(calc(-50%*3.1), -50%) translateZ(-50px)",
          zIndex: 1,
          transition: "all 0.5s ease",
          boxShadow: "none",
        };
      case 2: // 중앙 (메인)
        return {
          opacity: 1,
          pointerEvents: "auto",
          transform: "translate(-50%, -50%) translateZ(50px) scale(1.1)",
          zIndex: 3,
          boxShadow: "0 20px 40px rgba(0,0,0,0.5)",
          transition: "all 0.5s ease",
        };
      case 3: // 오른쪽 중간
        return {
          opacity: 0.5,
          pointerEvents: "none",
          transform: "translate(calc(-50%*-1.1), -50%) translateZ(-50px)",
          zIndex: 1,
          transition: "all 0.5s ease",
          boxShadow: "none",
        };
      default:
        return {};
    }
  };

  const openPasswordModal = (mode) => setPasswordMode(mode);
  const closePasswordModal = () => setPasswordMode(null);

  const handlePasswordSuccess = () => {
    if (passwordMode === "upload") {
      setShowUpload(true);
    }
    setPasswordMode(null);
  };

  const onClose = () => {
    setShowUpload(false);
    setImage(null);
    setImagePreview(null);
    setTitle("");
    setUrl("");
  };

  const onFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    setImage(file);
    setImagePreview(file ? URL.createObjectURL(file) : null);
  };

  const handleUpload = async () => {
    if (!image) return alert("이미지를 선택해주세요");
    if (!title.trim()) return alert("제목을 입력해주세요");
    if (!url.trim()) return alert("url을 입력해주세요");

    setLoading(true);

    try {
      const uniqueFileName = `${uuidv4()}_${image.name}`;
      const imageRef = storageRef(storage, `trpg/${uniqueFileName}`);
      await uploadBytes(imageRef, image);
      const imageUrl = await getDownloadURL(imageRef);

      await addDoc(collection(db, "trpg"), {
        title,
        url,
        imageUrl,
        fileName: uniqueFileName,
        createdAt: serverTimestamp(),
      });

      onClose();

      // 업로드 후 데이터 다시 불러오기
      const collRef = collection(db, "trpg");
      const q = query(collRef, orderBy("createdAt", "asc"));
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setItems(data);

      // 인덱스 초기화
      setIndex(0);
    } catch (err) {
      console.error(err);
      alert("업로드 실패 ㅠㅠ");
    } finally {
      setLoading(false); // 로딩 끝
    }
  };

  return (
    <div className="flex flex-col items-center w-full h-full">
      <div className="h-[20%] z-[50]">
        <div className="text-white text-6xl font-mochiy mt-[24%]">TRPG</div>
      </div>

      <Window
        className="w-full h-full shadow-sm relative"
        content={
          <div>
            <div className="relative w-full h-[55vh] flex justify-center items-center">
              {getFiveItems().map((item, pos) => {
                if (!item) return null;
                const { transform, zIndex, boxShadow, pointerEvents, opacity } = getStyleForPosition(pos);
                return (
                  <a
                    key={item.id}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-all duration-500 border border-black/10 absolute left-1/2 top-1/2 mt-[4vh]"
                    style={{ transform, zIndex, boxShadow, pointerEvents, opacity }}
                  >
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="w-full h-[55vh] object-cover"
                    />
                  </a>
                );
              })}

              {/* 버튼 */}
              <div className="absolute top-1/2 left-0 w-full flex justify-between items-center px-8 z-[50] -translate-y-1/2">
                <button
                  onClick={handlePrev}
                  className="bg-black bg-opacity-50 text-white px-4 py-2 rounded shadow-lg"
                >
                  ◀
                </button>
                <button
                  onClick={handleNext}
                  className="bg-black bg-opacity-50 text-white px-4 py-2 rounded shadow-lg"
                >
                  ▶
                </button>
              </div>
            </div>

            {showUpload && (
              <div className="absolute top-1/2 left-1/2 z-50 transform -translate-x-1/2 -translate-y-1/2 w-[320px] shadow-lg">
                <Window
                  content={
                    <div className="flex flex-col gap-4 items-center p-6 pt-9 rounded-lg shadow-lg w-[320px]">
                      <button
                        className="absolute top-0 right-3 w-3 h-3 z-[15]"
                        onClick={onClose}
                      />
                      {imagePreview && (
                        <img
                          src={imagePreview}
                          alt="미리보기"
                          className="w-auto h-full aspect-square rounded-lg mt-2 object-cover border border-gray-300"
                          style={{ filter: loading ? "blur(2px)" : "none", pointerEvents: loading ? "none" : "auto" }}
                        />
                      )}
                      <input
                        type="text"
                        placeholder="제목"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="w-full p-2 rounded border border-gray-300"
                        disabled={loading}
                      />
                      <input
                        type="text"
                        placeholder="URL"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        className="w-full p-2 rounded border border-gray-300"
                        disabled={loading}
                      />
                      <input
                        type="file"
                        accept="image/*"
                        className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-400 file:text-white hover:file:bg-blue-500 cursor-pointer"
                        onChange={onFileChange}
                        disabled={loading}
                      />
                      <button
                        className="bg-blue-400 hover:bg-blue-500 text-white py-2 px-6 rounded font-semibold transition mt-2"
                        onClick={handleUpload}
                        disabled={loading}
                      >
                        업로드하기
                      </button>

                      {loading && (
                        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-20">
                          <Loading />
                        </div>
                      )}
                    </div>
                  }
                />
              </div>
            )}

            {passwordMode && (
              <div className="absolute top-1/2 left-1/2 z-[100] transform -translate-x-1/2 -translate-y-1/2 w-[320px] shadow-lg">
                <Window
                  onClose={closePasswordModal}
                  content={
                    <Password
                      onClose={closePasswordModal}
                      onSuccess={handlePasswordSuccess}
                    />
                  }
                />
              </div>
            )}

            <button
              className="absolute bottom-4 right-12 text-white bg-blue-400 rounded-full w-12 h-12 text-4xl font-bold hover:bg-blue-500 transition z-50"
              onClick={() => openPasswordModal("upload")}
              aria-label="Open password modal"
            >
              +
            </button>
          </div>
        }
      />

      <div className='w-full flex justify-center'>
        <img src="/assets/logo2.png" alt="로고 이미지" className="h-[10vh] object-cover" />
      </div>
    </div>
  );
};

export default Trpg;
